import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { Col } from "react-bootstrap";
import loadRecord from "MODULES/shared/decorators/loadRecord";
import {
  AuditFields,
  ClipboardCopy,
  DashedSeparator,
  RecordPager
} from "MODULES/shared/components";
import { CODE } from "APP_ROOT/constants";
import { ShippingPreference } from "../../../Orders/shared/ShippingPreference";
import ShipTo from "./ShipTo";
import { show } from "../../actions";
import { DetailsTable } from "./DetailsTable";

function Detail({ rejectedCore }) {
  const parsedRejectedCore = rejectedCore.toJS();
  return (
    <Col>
      <div className="page-header page-header-bar">
        <h1>
          <div className="with-padding">
            <RecordPager baseUrl="/rejected-cores" record={rejectedCore} />
            <span className="header-content">{rejectedCore.get(CODE)}</span>
            <ClipboardCopy name={rejectedCore.get(CODE)} type="Rejected Core" />
          </div>
        </h1>
      </div>
      <Col md={3}>
        <div className="panel panel-default">
          <div className="panel-body">
            <DetailsTable rejectedCore={parsedRejectedCore} />
            <DashedSeparator />
            <ShipTo />
            <ShippingPreference
              shippingMethod={parsedRejectedCore.shipping_method}
            />
            <DashedSeparator />
            <AuditFields record={rejectedCore} multiLine />
          </div>
        </div>
      </Col>
    </Col>
  );
}

Detail.propTypes = {
  rejectedCore: T.instanceOf(Map)
};

export default connect(state => ({
  rejectedCore: state.rejectedCoreDetail.get("rejectedCore")
}))(
  loadRecord({
    reducer: "rejectedCoreDetail",
    name: "rejectedCore",
    action: show
  })(Detail)
);



// WEBPACK FOOTER //
// ./app/modules/RejectedCores/components/Detail/Detail.jsx